import { focusIndex } from './ViewletTitleBarMenuBarFocusIndex.js'

export const handleMouseOverMenuOpen = focusIndex
